module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/the-header/ja-JP/img_logo.png";